<div class="as-row as-align-center as-gap-10 as-justify-center">
  <mat-icon svgIcon="ic-error-exc"></mat-icon>
  <p class="as-size-16">
    {{ 'GENERAL.errorCode' | translate }} {{ data.code }}
  </p>
</div>
<p class="as-size-16">{{ data.message }}</p>
